const en_mitra_stock_req = {
    "": "item request",
    detail: "item request detail",
    add: "add item request",
    edit: "edit item request",

    label: {
        choose_mitra: "select partner / depo / HQ",
        date: "Target Delivery Date",
    },
}

export default en_mitra_stock_req;